import { login } from '../../redux/modules/auth';
import { connect } from 'react-redux';
import UserLogin from './user-login';

export default connect(
  ({ boligagents: { sessionPrefs } }) => ({ prefs: sessionPrefs }),
  { login }
)(UserLogin);
